import { render, staticRenderFns } from "./RefDataList.vue?vue&type=template&id=0d0b8811&"
import script from "./RefDataList.vue?vue&type=script&lang=js&"
export * from "./RefDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports